<section class="treatment-information-wrapper" [style.height]="therapiesAndTrailCalculatedDetailsHeight$ | async">
  <gen-tabs-header *ngIf="extendedTabs.length"
    (tabChange)="tabChanged($event)"
    (tabInit)="tabInit($event)"
    [styleModifier]="'info-section-headers'"
    [currentTab]="selectedTab?.label"
    [tabs]="extendedTabs"
    [ngClass]="section.cssClass">
  </gen-tabs-header>

  <ng-container *ngFor="let extendedTab of extendedTabs; let tabIndex = index; trackBy: trackByFn('label');">
    <ng-container *ngIf="extendedTab.label === selectedTab?.label" >
      <ng-container *ngIf="extendedTab.additionalData?.singlePanel">
        <section class="single-panel-section">
          <ng-container *ngIf="showTreatmentInformationPanel()">
            <gen-treatment-information
                    [panelConfiguration]="extendedTab.panels[0]"
                    [data]="extendedTab.panels[0].filteredData"
                    (treatmentInfoTabChanged)="panelUpdated()"
            >
            </gen-treatment-information>
          </ng-container>
        </section>
      </ng-container>

      <p-accordion
        *ngIf="!extendedTab.additionalData?.singlePanel"
        class="information-section"
        [ngClass]="{'no-height': layout}"
        [multiple]="false"
        (onOpen)="updateOpenStatus(true,$event.index,extendedTab)"
        (onClose)="updateOpenStatus(false,$event.index,extendedTab)"
        expandIcon="icon__expand" collapseIcon="icon__collapse"
      >
        <p-accordionTab
          *ngFor="let panel of extendedTab.panels; trackBy: trackByFn()"
          class="single-option-wrapper {{panel.cssClass}} {{(panel?.label || panel?.resource ) | automationLocator: 'ACCORDION'}}"
          [ngClass]="{'open': panel.openStatus}"
          [selected]="panel.openStatus"
        >
          <p-header>
            <section class="information-section-title">
              <span class="title-text">{{panel.label | stringTranslate}} <ng-container *ngIf="panel.amount > -1">({{panel.amount}})</ng-container></span>
            </section>
          </p-header>
          <ng-container>
            <div class="treatment-information-container">
              <gen-treatment-information
                      [panelConfiguration]="panel"
                      [customEmptyMessage]="extendedTab.emptyMessage"
                      [data]="panel.filteredData"
                      (treatmentInfoTabChanged)="panelUpdated()"
              ></gen-treatment-information>
            </div>
          </ng-container>
        </p-accordionTab>
      </p-accordion>
    </ng-container>
  </ng-container>

  <ispm-copyright [useConfiguration]="true"></ispm-copyright>
</section>

<gen-overlay-loader
        *ngIf="isLoading"
        class="loader-wrapper">
</gen-overlay-loader>


